import { modalContactEventPush } from "./components/modalEventPush";
import modalResponseRender from "./components/modalResponseRender";
import modalSpinner from "./components/modalSpinner";
import addModalUrlAutoComplete from './components/modalAutoComplete';
import getCookies from './components/getCookies';


export default function setContactModalHandlers(wpcfModalSelector) {
    let wpcfModalEventLabel     = $(wpcfModalSelector).data('event-slug');

    let dataAttributesList = $(wpcfModalSelector).data();
    let customResponse = $(wpcfModalSelector).data('custom-response');

    let wpcfModalNativeSelectors = document.querySelectorAll( `${wpcfModalSelector} .form-holder>.wpcf7` );
    if(!wpcfModalNativeSelectors) return;
    let isNotSentModalForm     = true;

    $(wpcfModalSelector).on('show.bs.modal', function () {

        import(/* webpackChunkName: "chunk.select2" */ 'select2').then(() => {
            $(`${wpcfModalSelector} select.form-control.select2-search`).select2({
                dropdownParent: $(wpcfModalSelector),
                minimumResultsForSearch: 1
            });

            $(`${wpcfModalSelector} select.form-control`).not(".select2-search").select2({
                minimumResultsForSearch: -1
            });
        });
        
        $.get("https://ipinfo.io", function (response) {
            $(wpcfModalSelector).find('[name=user-ip]')
                .val(response.ip);
        }, "jsonp");

        if (document.cookie.indexOf('eos_user_id=') >= 0) {
            $.ajax({
                type: 'GET',
                xhrFields: {withCredentials: true},
                url: 'https://auth.eos.com/account/details/',
                success: function (response) {

                    let user_name = $(wpcfModalSelector).find('[name=user-name]');
                    let first_name = $(wpcfModalSelector).find('[name=first-name]');
                    let last_name = $(wpcfModalSelector).find('[name=last-name]');
                    let email = $(wpcfModalSelector).find('[name=user-email]');


                    if (response.first_name) {
                        first_name.val(response.first_name).parent().parent('.form-field').addClass('not-empty');
                    }

                    if (response.last_name) {
                        last_name.val(response.last_name).parent().parent('.form-field').addClass('not-empty');
                    }

                    if (response.first_name && response.last_name) {

                        user_name.val(response.first_name + ' ' + response.last_name).parent().parent('.form-field').addClass('not-empty');
                    }

                    if (response.email) {
                        email.val(response.email).parent().parent('.form-field').addClass('not-empty');
                    }
                },
            })
        }
    });

    $(wpcfModalSelector).on('hide.bs.modal', function () {

        $('html').removeClass('modal-open');

        if(isNotSentModalForm){
            modalContactEventPush(wpcfModalSelector, 'Close', wpcfModalEventLabel);
        }else{
            isNotSentModalForm = true;
        }

        $(wpcfModalSelector).find('.form-field').removeClass('not-empty disabled');
        $(wpcfModalSelector).find('[readonly]').attr("readonly", false);

        wpcfModalNativeSelectors.forEach(function (wpcfModalNativeSelector) {
            let wpcfFormNativeSelector  = wpcfModalNativeSelector.querySelector( 'form' );
            if (!wpcfFormNativeSelector) return;
            wpcfFormNativeSelector.reset();
        });

        // sessionStorage.removeItem(wpcfModalSelector);
    });

    $(wpcfModalSelector).on('shown.bs.modal', function () {
        let modalData = JSON.parse(sessionStorage.getItem(wpcfModalSelector));
        if (modalData) {
            let modalDisabledFields = modalData['modal-disabled'];
            let modalAutocompleteFields = modalData['modal-autocomplete'];

            for (const property in modalAutocompleteFields) {
                let field = $(wpcfModalSelector).find(`[name=${property}]`);
                if (field.is('select')) {
                    field.val(modalAutocompleteFields[property]).trigger("change");
                    field.parent().parent('.form-field').addClass('not-empty');
                } else {
                    field
                        .val(modalAutocompleteFields[property])
                        .parent().parent('.form-field').addClass('not-empty');
                }
            }

            for (const property in modalDisabledFields) {
                $(wpcfModalSelector)
                    .find(`[name=${property}]`)
                    .attr('readonly', modalDisabledFields[property])
                    .parent().parent().addClass('disabled');
            }
        }

        modalContactEventPush(wpcfModalSelector, 'Show', wpcfModalEventLabel);

    });


    wpcfModalNativeSelectors.forEach(function (wpcfModalNativeSelector) {

        let wpcfFormNativeSelector  = wpcfModalNativeSelector.querySelector( 'form' );
        if (!wpcfFormNativeSelector) return;

        wpcfFormNativeSelector.addEventListener( 'submit', function(event) {
            modalContactEventPush(wpcfModalSelector, 'submit');
            modalSpinner( wpcfModalSelector, 'start') 
        }, false );

        wpcfModalNativeSelector.addEventListener( 'wpcf7mailsent', function( event ) {
            isNotSentModalForm     = false;
            
            function getProductname() {
                if(wpcfModalSelector === '#modalRegistrationSingleForm'|| wpcfModalSelector === '#modalRegistrationGroupForm') {
                    
                    let productSelected = wpcfModalNativeSelector.querySelector('form select[name="product"]');
                    let productSelectedValue = productSelected.options[productSelected.selectedIndex].value;
                    
                    if (productSelectedValue === 'EOSDA Crop Monitoring') {
                        return 'cm'
                    } else if (productSelectedValue === 'EOSDA LandViewer') {
                        return 'lv'
                    } else {
                        return
                    }
                }
                else {
                    return
                }
            }
            modalResponseRender(event, dataAttributesList, customResponse);
            modalContactEventPush(wpcfModalSelector, 'Success', wpcfModalEventLabel, getProductname());
            modalSpinner( wpcfModalSelector, 'stop');
            $(wpcfModalSelector).modal('hide');
            $('.form-upload-file').removeClass('active');
        }, false);


        wpcfModalNativeSelector.addEventListener( 'wpcf7mailfailed', function( event ) {
            isNotSentModalForm     = false;
            modalResponseRender(event, dataAttributesList);
            modalContactEventPush(wpcfModalSelector, 'Error', wpcfModalEventLabel, false, `status - ${event.detail.status}`);
            modalSpinner( wpcfModalSelector, 'stop');
            $(wpcfModalSelector).modal('hide');
        }, false );

        wpcfModalNativeSelector.addEventListener( 'wpcf7spam', function( event ) {
            isNotSentModalForm     = false;
            modalResponseRender(event, dataAttributesList);
            modalContactEventPush(wpcfModalSelector, 'Error', wpcfModalEventLabel, false, `status - ${event.detail.status}`)
            modalSpinner( wpcfModalSelector, 'stop');
            $(wpcfModalSelector).modal('hide');
        }, false );

        wpcfModalNativeSelector.addEventListener( 'wpcf7invalid', function( event ) {
            let arr = []; let eventContent = [];
            event.detail.apiResponse.invalid_fields.map(item=>arr.push(item.field));
            const getValue = (key) => event.detail.inputs.find(el => el.name == key) ? event.detail.inputs.find(el => el.name == key).value : '';
            for(let i = 0; i < arr.length; i++) eventContent.push(`${arr[i]} - ${getValue(arr[i])}`);
            modalContactEventPush(wpcfModalSelector, 'Error', wpcfModalEventLabel, false, eventContent.join(', '));
            modalSpinner( wpcfModalSelector, 'stop');
        }, false);
    });

    addModalUrlAutoComplete( wpcfModalSelector );
}
